import PropTypes from 'prop-types';
import Button from 'Components/Atoms/Button/Button';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormProvider, { RHFInput, RHFSelect } from 'Components/Organisms/HookForm';
import * as yup from 'yup';
import clsx from 'clsx';
import classes from './ForecastValueCreate.module.css';
import Divider from 'Components/Atoms/Divider/Divider';
import { useTranslation } from 'react-i18next';
import useRepeatsByPeriodicity from './useRepeatsByPeriodicity';

export default function ForecastValueCreateFixedForm(props) {
    const { processing, onCancel, onSubmit, className, periodicity, periodKey, defaultValues } = props;
    const { repeat_for, repeat_every } = useRepeatsByPeriodicity({ periodicity, periodKey });

    const { t } = useTranslation('forecasts');

    const forecastValueSchema = yup.object().shape({
        reference_value: yup
            .number(t('validations.value-must-be-valid'))
            .min(0, t('validations.value-must-be-bigger-than-zero'))
            .required(t('validations.value-required')),
        repeat_for: yup.number(t('validations.value-must-be-valid')).required(t('validations.value-required')),
        repeat_every: yup.number(t('validations.value-must-be-valid')).required(t('validations.value-required')),
    });

    const methods = useForm({
        resolver: yupResolver(forecastValueSchema),
        defaultValues: {
            reference_value: 0,
            repeat_for: repeat_for[0].id,
            repeat_every: repeat_every[0].id,
            ...defaultValues,
        },
    });

    const { handleSubmit, watch } = methods;

    const hasRepetition = watch('repeat_for') > 1;

    return (
        <FormProvider
            className={clsx('flex flex-col grow', className)}
            methods={methods}
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="grid gap-6 pb-1">
                <div className={classes.card}>
                    <div className={classes.label}>{t('cell.value')}</div>
                    <RHFInput type="number" inputProps={{ step: 0.1 }} name="reference_value" />
                </div>

                <Divider className="my-1" />

                <div className={classes.card}>
                    <div className="flex justify-content-evenly gap-2">
                        <div className="grow">
                            <div className={classes.label}>{t('cell.repetition')}</div>
                            <RHFSelect className="w-full" name="repeat_for" options={repeat_for} />
                        </div>
                        <div className="grow">
                            <div className={classes.label}>{t('cell.every')}</div>
                            <RHFSelect
                                className="w-full"
                                name="repeat_every"
                                options={repeat_every}
                                disabled={!hasRepetition}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grow" />

            <div className="sticky bottom-0 bg-white py-6">
                <div className="flex gap-2">
                    <Button variant="primary" type="submit" className="grow" isBusy={processing}>
                        {t('cell.apply')}
                    </Button>
                    <Button className="grow" onClick={onCancel}>
                        {t('cell.cancel')}
                    </Button>
                </div>
            </div>
        </FormProvider>
    );
}

ForecastValueCreateFixedForm.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    processing: PropTypes.bool,
    className: PropTypes.string,
    periodicity: PropTypes.string,
    periodKey: PropTypes.string,
    defaultValues: PropTypes.object,
};
